import type React from "react";
import { motion } from "framer-motion";


export const StatCard: React.FC<{
  icon: React.ReactNode;
  title: string;
  value: string | number;
  subtitle?: string;
  color: 'blue' | 'green' | 'purple' | 'amber' | 'rose' | 'indigo' | 'emerald';
  trend?: number;
}> = ({ icon, title, value, subtitle, color, trend }) => {
  const colorClasses = {
    blue: 'from-blue-500 to-blue-600',
    green: 'from-green-500 to-green-600',
    purple: 'from-purple-500 to-purple-600',
    amber: 'from-amber-500 to-amber-600',
    rose: 'from-rose-500 to-rose-600',
    indigo: 'from-indigo-500 to-indigo-600',
    emerald: 'from-emerald-500 to-emerald-600'
  };

  const bgClasses = {
    blue: 'bg-blue-50 border-blue-100',
    green: 'bg-green-50 border-green-100',
    purple: 'bg-purple-50 border-purple-100',
    amber: 'bg-amber-50 border-amber-100',
    rose: 'bg-rose-50 border-rose-100',
    indigo: 'bg-indigo-50 border-indigo-100',
    emerald: 'bg-emerald-50 border-emerald-100'
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className={`relative rounded-2xl p-6 border ${bgClasses[color]} overflow-hidden`}
    >
      <div className="absolute -right-6 -bottom-6 w-24 h-24 opacity-10">
        <div className={`w-full h-full rounded-full bg-gradient-to-br ${colorClasses[color]}`} />
      </div>
      
      <div className="relative z-10">
        <div className="flex items-center justify-between mb-4">
          <div className={`p-3 rounded-xl bg-white shadow-sm border`}>
            {icon}
          </div>
          {trend !== undefined && (
            <span className={`px-3 py-1 rounded-full text-sm font-medium ${
              trend >= 0 
                ? 'bg-green-100 text-green-800 border border-green-200' 
                : 'bg-red-100 text-red-800 border border-red-200'
            }`}>
              {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}%
            </span>
          )}
        </div>
        
        <h3 className="text-sm font-medium text-gray-600 mb-1">
          {title}
        </h3>
        <p className="text-3xl font-bold text-gray-900 mb-2">
          {value}
        </p>
        {subtitle && (
          <p className="text-sm text-gray-500">
            {subtitle}
          </p>
        )}
      </div>
    </motion.div>
  );
};